import { useStaticQuery, graphql } from 'gatsby';

const useBusiness = () => {
  const data = useStaticQuery(graphql`
    query useBusinessQuery {
      sanityBusiness {
        name
        owner
        yearOpened
        license
        slogan
        address
        city
        stateLong
        stateShort
        zip
        county
        country
        phone
        email
        hoursWeek
        hoursMon
        hoursTue
        hoursWed
        hoursThu
        hoursFri
        hoursSat
        hoursSun
        websiteUrl
        gbpUrl
        gbpEmbed
        facebookUrl
        instagramUrl
        twitterUrl
        linkedInUrl
        youTubeUrl
        tikTokUrl
        yelpUrl
      }
    }
  `);

  const business = data.sanityBusiness;

  return business;
};

export { useBusiness };
